import { DEFAULT_ROLES } from '@conversed/shared/src/central/constants/permissions';
import type { CreateMemberDTO } from '@conversed/shared/src/central/dto/company';
import { getNewMemberValidationSchema } from '../../../helpers/validationSchemaHelpers';
import { useValidationForm } from '../../useValidationForm';
import useRole from '../roles/useRole';
import { useCompanySettingsActions } from './useCompanyActions';

export const useNewMemberForm = () => {
  const { addMember } = useCompanySettingsActions();
  const { assignableRoles } = useRole();
  const defaultRoles = [DEFAULT_ROLES.LIVE_CHAT_AGENT_ROLE];
  const { reset, handleSubmit, watch, control, setValue } =
    useValidationForm<CreateMemberDTO>({
      schema: getNewMemberValidationSchema(),
      defaultValues: {
        firstName: '',
        lastName: '',
        email: '',
        roles: defaultRoles,
      },
      shouldUseNativeValidation: true,
    });

  const submit = handleSubmit((data) => {
    addMember(data);
    reset();
  });

  return {
    assignableRoles,
    defaultRoles,
    submit,
    watch,
    control,
    handleSubmit,
    setValue,
  };
};
